import axios from './axiosConfig';
import { NOTIFICATION_API } from '../constants/api';

/**
 * Gửi thông báo tùy chỉnh
 * @param {Object} data - Dữ liệu thông báo
 * @param {string|Array} data.recipients - Danh sách ID người nhận hoặc 'all' để gửi cho tất cả
 * @param {string} data.subject - Tiêu đề thông báo
 * @param {string} data.content - Nội dung thông báo
 * @param {string} data.notificationType - Loại thông báo (utility, important, general...)
 * @param {Array} [data.factoryIds] - Danh sách ID xưởng ảnh hưởng (tùy chọn)
 * @param {string} [data.scheduledDate] - Ngày áp dụng (tùy chọn)
 * @param {string} [data.scheduledTime] - Thời gian áp dụng (tùy chọn)
 * @param {string} [data.duration] - Thời lượng (tùy chọn)
 * @returns {Promise} Promise API
 */
const sendCustomNotification = (data) => {
  return axios.post(NOTIFICATION_API.CREATE, data);
};

/**
 * Lấy danh sách thông báo tùy chỉnh
 * @param {Object} params - Tham số truy vấn
 * @param {string} [params.tenantId] - ID của khách hàng
 * @param {string} [params.type] - Loại thông báo cần lọc
 * @param {number} [params.page=1] - Số trang
 * @param {number} [params.limit=10] - Số lượng thông báo trên mỗi trang
 * @returns {Promise} Promise API
 */
const getCustomNotifications = (params = {}) => {
  return axios.get(NOTIFICATION_API.LIST, { params });
};

/**
 * Đánh dấu thông báo đã đọc
 * @param {string} notificationId - ID của thông báo
 * @returns {Promise} Promise API
 */
const markNotificationAsRead = (notificationId) => {
  return axios.put(`${NOTIFICATION_API.READ}/${notificationId}`);
};

/**
 * Xóa thông báo
 * @param {string} notificationId - ID của thông báo
 * @returns {Promise} Promise API
 */
const deleteNotification = (notificationId) => {
  return axios.delete(`${NOTIFICATION_API.DELETE}/${notificationId}`);
};

const notificationService = {
  sendCustomNotification,
  getCustomNotifications,
  markNotificationAsRead,
  deleteNotification,
};

export default notificationService; 